import { useLocation } from "react-router";

/**
 * @description to replace useParams
 */
export function useCustomParams() {
  const location = useLocation();
  const pathname = location.pathname;

  const [level1, level2, level3, level4, level5, level6] = pathname
    .split("/")
    .filter(Boolean);

  return {
    level1: level1 || "",
    level2: level2 || "",
    level3: level3 || "",
    level4: level4 || "",
    level5: level5 || "",
    level6: level6 || "",
  };
}
